import { ApiProperty } from '@nestjs/swagger';
import { IsInt, IsNotEmpty, IsOptional, IsString, MaxLength } from 'class-validator';

export class CreateAtributoDto {
  @ApiProperty({ example: 'Color', description: 'Nombre del atributo' })
  @IsNotEmpty()
  @IsString()
  @MaxLength(100)
  nombre: string;

  @ApiProperty({ example: 'Color del producto', description: 'Descripción del atributo', required: false })
  @IsOptional()
  @IsString()
  @MaxLength(255)
  descripcion?: string;

  @ApiProperty({ example: 0, description: 'Orden de visualización', required: false })
  @IsOptional()
  @IsInt()
  orden?: number;
}
